import { upperFirst } from 'lodash-es'
import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import _Error from "error_message-Error.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/error_message.js?styleId=Error";

const errorColor = 'var(--color-error, #C84545)'
const textColorSecondary4 = 'var(--text-color-secondary-4, rgba(255, 255, 255, 1))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const colorStrokeDestructive = 'var(--colorStrokeDestructive, var(--coreColorRed600))'

const formatErrorMessage = (message) => {
  message = upperFirst(message)
  if (message.slice(-1) !== '.') {
    message = `${message.trim()}.`
  }
  return message
}

const Error = /*#__PURE__*/styled('div', null, {
  displayName: "Error",
  styles: _Error
})

const ErrorMessage = ({ message = null, id = null, ...rest }) => {
  if (!(message && message.length)) return null

  const errors = Array.isArray(message) ? message : [message]

  return (
    <div data-component="error-message" {...rest}>
      {errors.map((error) => (
        <Error key={error} aria-describedby={id}>
          {formatErrorMessage(error)}
        </Error>
      ))}
    </div>
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
}

export default ErrorMessage
